import { useLang } from '../i18n';

const INSTAGRAM_URL = 'https://www.instagram.com/supermufflerinc?igsh=NTc4MTIwNjQ2YQ==';
const MESSENGER_URL = 'https://www.facebook.com/supermufflerinc?mibextid=wwXIfr&mibextid=wwXIfr';

function InstagramIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  );
}

function MessengerIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.2 5.42 3.15 7.2.16.15.26.36.27.58l.05 1.82c.02.61.64 1.01 1.21.78l2.03-.82c.17-.07.36-.09.55-.05.96.26 1.98.4 3.04.4h.02C17.64 21.6 22 17.48 22 11.91v-.01C22 6.34 17.64 2.22 12.3 2H12zm5.87 7.56l-2.87 4.56c-.46.73-1.45.9-2.12.37l-2.28-1.71a.56.56 0 0 0-.68 0l-3.08 2.34c-.41.31-.95-.18-.67-.62l2.87-4.56c.46-.73 1.45-.9 2.12-.37l2.28 1.71c.2.15.49.15.68 0l3.08-2.34c.41-.31.95.18.67.62z"/>
    </svg>
  );
}

export default function ThankYou() {
  const { t } = useLang();

  return (
    <div className="thankyou-page" data-testid="thank-you-page">
      <div className="thankyou-card" data-testid="thank-you-card">
        <div className="thankyou-check" data-testid="thank-you-check">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>
        <h1 className="thankyou-h1" data-testid="thank-you-headline">{t.tyHeadline}</h1>
        <p className="thankyou-body">
          {t.tyBody.split('\n').map((line, i) => (
            <span key={i}>{line}{i === 0 ? <br /> : ''}</span>
          ))}
        </p>
        <div className="thankyou-buttons">
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="thankyou-btn thankyou-btn-ig" data-testid="thank-you-instagram-btn">
            <InstagramIcon /> {t.tyInstagram}
          </a>
          <a href={MESSENGER_URL} target="_blank" rel="noopener noreferrer" className="thankyou-btn thankyou-btn-fb" data-testid="thank-you-messenger-btn">
            <MessengerIcon /> {t.tyMessenger}
          </a>
        </div>
      </div>
    </div>
  );
}
